import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export function markAllModified(control: AbstractControl, markOnlyPopulated = false, onlySelf = true) {
  if ((markOnlyPopulated && control.value) || !markOnlyPopulated) {
    control.markAsDirty({ onlySelf });
    control.markAsTouched({ onlySelf });
  }

  if (control instanceof UntypedFormGroup) {
    Object.keys(control.controls).forEach(key => markAllModified(control.controls[key], markOnlyPopulated));
  } else if (control instanceof UntypedFormArray) {
    control.controls.forEach(con => markAllModified(con, markOnlyPopulated));
  }
}

export function markAllUnmodified(control: AbstractControl, onlySelf = true) {
  control.markAsPristine({ onlySelf });
  control.markAsUntouched({ onlySelf });

  if (control instanceof UntypedFormGroup) {
    Object.keys(control.controls).forEach(key => markAllUnmodified(control.controls[key]));
  } else if (control instanceof UntypedFormArray) {
    control.controls.forEach(con => markAllUnmodified(con));
  }
}

export function setRequired(control: AbstractControl) {
  if (control instanceof UntypedFormControl) {
    control.setValidators([Validators.required]);
  } else if (control instanceof UntypedFormGroup) {
    Object.keys(control.controls).forEach(key => setRequired(control.controls[key]));
  } else if (control instanceof UntypedFormArray) {
    control.controls.forEach(con => setRequired(con));
  }
}

export function isEmptyAndNotFocused(control: AbstractControl): boolean {
  const isEmptyAndNotTouched: boolean = control.pristine && control.untouched;
  return !control.value && (isEmptyAndNotTouched || control.touched);
}

export function removeInvalidFormArrayItems(array: UntypedFormArray) {
  for (let i = array.length - 1; i >= 0; i--) {
    if (array.at(i).invalid) {
      array.removeAt(i);
    }
  }
}